import { IChatbotPart } from './part';
import { IChatbotQuestion } from './question';

export enum ChatbotResponseType {
  MESSAGE = 'message',
  QUESTIONS = 'questions',
  PARTS_LIST = 'parts-list',
}

export interface IChatbotMessageResponse {
  type: typeof ChatbotResponseType.MESSAGE;
  title?: string;
  message?: string;
}

export interface IChatbotQuestionsResponse {
  type: typeof ChatbotResponseType.QUESTIONS;
  title?: string;
  questions: IChatbotQuestion[];
}

export interface IChatbotPartsListResponse {
  type: typeof ChatbotResponseType.PARTS_LIST;
  title?: string;
  parts: IChatbotPart[];
}

export type IChatbotResponse =
  | IChatbotMessageResponse
  | IChatbotQuestionsResponse
  | IChatbotPartsListResponse;
